import { useQuery } from "@tanstack/react-query";
import { CurrencyDto, UserProfileDto, UserRole } from "@green0meter/api-client";

import { DOMAIN_CURRENCIES } from "../domain";

import { currenciesApi } from "@api/services";
import { TANSTACK_QUERY_STALE_TIME } from "@constants";
import { roleGuard } from "@api";

export const ACTION_GET_CURRENCIES = "GET_CURRENCIES";

const allowedRoles = [
  UserRole.Owner,
  UserRole.Manager,
  UserRole.Respondent,
  UserRole.Viewer,
  UserRole.Auditor,
];

const getCurrencies = async (): Promise<CurrencyDto[]> => {
  const response = await currenciesApi.currenciesControllerGetCurrencies();

  return response.data;
};

export const useGetCurrencies = (
  user: UserProfileDto | null,
): {
  currencies: CurrencyDto[];
  currenciesEnabled: boolean;
  isPendingGetCurrencies: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const { isPending, data = [] } = useQuery({
    queryKey: [DOMAIN_CURRENCIES, ACTION_GET_CURRENCIES],
    queryFn: () => getCurrencies(),
    select: (response) => response,
    staleTime: TANSTACK_QUERY_STALE_TIME,
    enabled,
  });

  return {
    isPendingGetCurrencies: isPending,
    currenciesEnabled: enabled,
    currencies: data,
  };
};
